// extracted by mini-css-extract-plugin
module.exports = {"section":"black-friday-cyber-monday-sales_section__foW4h","fill-background":"black-friday-cyber-monday-sales_fill-background__xzFo3"};